import script from "./BattleIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./BattleIndex.vue?vue&type=script&setup=true&lang=js"

import "./BattleIndex.vue?vue&type=style&index=0&id=6372b8a8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6372b8a8"]])

export default __exports__